// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import CheckboxSelect from 'fg-frontend/src/components/CheckboxSelect';
import GoBack from './components/GoBack';
import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';
import SocialShare from 'fg-frontend/components/SocialShare';
import RadioSelectTab from 'fg-frontend/src/components/RadioSelectTab';
import ShareUrl from 'fg-frontend/src/components/ShareUrl';
import Form from 'fg-frontend/src/components/Form';
import AddSvgIconSprite from './components/AddSvgIconSprite';
import GtmHandler from './components/GtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
import LazyImage from './components/LazyImage';
import FGUpload from './components/FGUpload';
import SectionList from './components/SectionList';
import ColorDescriptionSlider from './components/ColorDescriptionSlider';
// ESHOP: ovládání modálního okna pro popis variantní barvy
import ColorDescriptionModal from './components/ColorDescriptionModal';
// COMMON: Komponenta pro pocitani pristupu na stranku a odeslani pred DL push
import PageViewCount from './components/PageViewCount';
// COMMON: Komponenta pro vyresetovaní filtracniho formulare
import FilterFormReset from './components/FilterFormReset';

import configureEshopComponents from './configureConfiguratorEshopComponents';

export default (props) => {
    switch (props.decorator || props.is) {
        case 'AddSvgIconSprite':
            return AddSvgIconSprite;
        case 'GoBack':
          return GoBack;
        case 'RadioSelect':
            return RadioSelect;
        case 'CheckboxSelect':
            return CheckboxSelect;
        case 'SimpleCollapse':
            return SimpleCollapse;
        case 'SocialShare':
            return SocialShare;
        case 'RadioSelectTab':
            return RadioSelectTab;
        case 'GtmHandler':
            return GtmHandler;
        case 'TriggerInViewport':
            return TriggerInViewport;
        case 'ShareUrl':
            return ShareUrl;
        case 'Form':
            return Form;
        case 'LazyImage':
            return LazyImage;
        case 'FGUpload':
            return FGUpload;
        case 'SectionList':
            return SectionList;
        case 'PageViewCount':
            return PageViewCount;
        case 'FilterFormReset':
            return FilterFormReset;
        case 'ColorDescriptionSlider':
            return ColorDescriptionSlider;
        case 'ColorDescriptionModal':
            return ColorDescriptionModal;
        case 'Configurator':
            return import('./components/configurator/Configurator');
        default:
            const eshopComponent = configureEshopComponents(props);
            if (eshopComponent) {
                return eshopComponent;
            } else {
                console.log(`Unknown component ${props.decorator || props.is}`);
                return null;
            }
    }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureConfiguratorComponents.js